import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const regulogEldConfig: TSPConfig = {
  key: 'regulogeld',
  name: 'Regulog ELD',
  imageName: 'regulog_eld',
  category: TSPCategory.CUSTOM,
  helpText:
    "Please input the company ID from your Regulog ELD profile. It should start with 'Company:' (like 'Company:12345').",
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'Enter Regulog ELD Company ID (e.g. Company:12345)',
          name: 'apikey',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default regulogEldConfig;
